var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUploadDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#06113c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 51.75a.75.75 0 0 0-.75.75V57c0 1.24-1.01 2.25-2.25 2.25H13c-1.24 0-2.25-1.01-2.25-2.25v-.25H41a3.715 3.715 0 0 0 3.565-2.606.75.75 0 1 0-1.431-.449A2.222 2.222 0 0 1 41 55.25H7c-1.24 0-2.25-1.01-2.25-2.25V14.75H12A2.753 2.753 0 0 0 14.75 12V4.75h4.65a.75.75 0 0 0 0-1.5H14c-.2 0-.39.08-.53.22l-10 10a.75.75 0 0 0-.22.53v39A3.755 3.755 0 0 0 7 56.75h2.25V57A3.755 3.755 0 0 0 13 60.75h34A3.755 3.755 0 0 0 50.75 57v-4.5a.75.75 0 0 0-.75-.75zm-38-38.5H5.81l7.44-7.44V12c0 .69-.56 1.25-1.25 1.25zM47 7.25h-2.25V7A3.755 3.755 0 0 0 41 3.25H26.98a.75.75 0 0 0 0 1.5H41c1.24 0 2.25 1.01 2.25 2.25v3.09a.75.75 0 0 0 1.5 0V8.75H47c1.24 0 2.25 1.01 2.25 2.25v.52a.75.75 0 0 0 1.5 0V11A3.755 3.755 0 0 0 47 7.25zM22.38 4.75h1.564a.75.75 0 0 0 0-1.5H22.38a.75.75 0 0 0 0 1.5z",
    fill: "#06113c",
    opacity: 1,
    "data-original": "#06113c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 21.75h11.96a.75.75 0 0 0 0-1.5H11a.75.75 0 0 0 0 1.5zM11 27.75h9.58a.75.75 0 0 0 0-1.5H11a.75.75 0 0 0 0 1.5zM11 33.75h9.03a.75.75 0 0 0 0-1.5H11a.75.75 0 0 0 0 1.5zM11 39.75h10.15a.75.75 0 0 0 0-1.5H11a.75.75 0 0 0 0 1.5zM11 44.25a.75.75 0 0 0 0 1.5h13.27a.75.75 0 0 0 0-1.5z",
    fill: "#06113c",
    opacity: 1,
    "data-original": "#06113c",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ff8c32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 40.336a.75.75 0 0 0 .75-.75v-14.19l4.72 4.72a.747.747 0 0 0 1.06 0 .75.75 0 0 0 0-1.06l-5.293-5.293a1.753 1.753 0 0 0-2.474 0l-5.293 5.293a.75.75 0 1 0 1.06 1.06l4.72-4.72v14.19c0 .414.336.75.75.75z",
    fill: "#26a5d9",
    opacity: 1,
    "data-original": "#ff8c32",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 13.25c-10.339 0-18.75 8.411-18.75 18.75S31.661 50.75 42 50.75a18.67 18.67 0 0 0 12.917-5.16.75.75 0 1 0-1.033-1.087A17.175 17.175 0 0 1 42 49.25c-9.512 0-17.25-7.738-17.25-17.25S32.488 14.75 42 14.75 59.25 22.488 59.25 32c0 3.396-.985 6.68-2.849 9.497a.752.752 0 0 0 1.252.828A18.67 18.67 0 0 0 60.75 32c0-10.339-8.411-18.75-18.75-18.75z",
    fill: "#26a5d9",
    opacity: 1,
    "data-original": "#ff8c32",
    className: ""
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadDoc);
export default __webpack_public_path__ + "static/media/icon-upload-doc.c8093645fa365bee3c6f07fd220f90e4.svg";
export { ForwardRef as ReactComponent };